"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networksId = exports.tokenDecimals = exports.ubiManagementSubgraphCeloAlfajores = exports.ubiManagementSubgraphCeloMainnet = exports.subgraphCeloAlfajores = exports.subgraphCeloMainnet = void 0;
const bignumber_js_1 = require("bignumber.js");
exports.subgraphCeloMainnet = 'https://api.thegraph.com/subgraphs/name/impactmarket/subgraph';
exports.subgraphCeloAlfajores = 'https://api.thegraph.com/subgraphs/name/impactmarket/alfajores-subgraph';
exports.ubiManagementSubgraphCeloMainnet = 'https://api.thegraph.com/subgraphs/name/impactmarket/ubi-management';
exports.ubiManagementSubgraphCeloAlfajores = 'https://api.thegraph.com/subgraphs/name/impactmarket/ubi-management-alfajores';
exports.tokenDecimals = new bignumber_js_1.BigNumber(10).pow(18);
exports.networksId = {
    CeloAlfajores: 44787,
    CeloMainnet: 42220
};
//# sourceMappingURL=config.js.map